<ng-template #addTicketNoteModalForm role="document" let-modal>

  @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  }

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">
      <div class="modal-body" style="padding-top: 10px;">
        <div class="row">
          <div class="col-6">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">Company</label>
              <input autocomplete="no-fill" type="text" [value]="ticket?.company"  class="form-control" placeholder="" readonly />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">Raised By</label>
              <input autocomplete="no-fill" type="text" [value]="ticket?.requester"  class="form-control" placeholder="" readonly />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">Type</label>
              <input autocomplete="no-fill" type="text" [value]="ticket?.type"  class="form-control" placeholder="" readonly />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">Title</label>
              <input autocomplete="no-fill" type="text" [value]="ticket?.title"  class="form-control" placeholder="" readonly />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">Affected User</label>
              <input autocomplete="no-fill" type="text" [value]="ticket?.affectedUser"  class="form-control" placeholder="" readonly />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">ICCID</label>
              <input autocomplete="no-fill" type="text" [value]="ticket?.iccid"  class="form-control" placeholder="" readonly />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mb-2">
              <label class="form-label text-right" style="margin-bottom: 4px;">Details</label>
              <textarea #details
                class="form-control"
                data-lpignore="true"
                rows="6"
                [ngModel]="ticket?.details"
                (keyup)="onDetailsChange(details.value)">
              </textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="display: flex; justify-content: space-between;">
            <div class="input-group mb-3">
              <label class="form-check-label mb-0">High Priority&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <div class="mb-0">
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  [(ngModel)]="ticket!.highPriority"
                  style="transform: scale(1.3);"
                  (click)="onHighPriorityCheckboxChange($event)"
                />
              </div>
            </div>
            </div>
          </div>
        </div>
        @if(this.showAddNoteInfo == true) {
          <div class="row">
            <div class="col-12">
              <div class="mb-1">
                <label class="form-label text-right">Add Note</label>
                <textarea [formControl]="newComment" class="form-control" rows="6"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="hstack gap-2 justify-content-end">
                @if(!embeddedFormMode) {
                  <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeAddNote()">Cancel</button>
                }
                <button type="button" class="btn btn-success" id="add-btn" [disabled]="!addNoteButtonEnabled" (click)="addNote()">Add Note</button>
              </div>
            </div>
          </div>
        }
        @if(this.showAddReplyInfo == true) {
          <div class="row">
            <div class="col-12">
              <div class="mb-1">
                <label class="form-label text-right">Reply</label>
                <textarea [formControl]="newReply" class="form-control" rows="6"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="hstack gap-2 justify-content-end">
                @if(!embeddedFormMode) {
                  <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeAddReply()">Cancel</button>
                }
                <button type="button" class="btn btn-success" id="add-reply-btn" [disabled]="!addReplyButtonEnabled" (click)="addReply()">Send Reply</button>
              </div>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="row">
                <div class="col-6">
                  <label class="form-label text-right" style="margin-bottom: 4px;">Notes & Replies</label>
                </div>
                <div class="col-6" style="padding-bottom: 5px;">
                  @if(this.showAddNoteInfo == false && this.showAddReplyInfo == false) {
                    <div class="hstack gap-2 justify-content-end">
                      <div class="list-inline-item edit">
                        <a href="javascript:void(0);" class="text-black d-inline-block edit-item-btn mb-1" (click)="showAddReply()">
                          <i class="ri-mail-line fs-14 border rounded p-2" style="border-color:'#767676;'" tooltipClass="custom-tooltip-sucess" [ngbTooltip]="showTooltips ? 'Send Reply' : null"></i>
                        </a>
                      </div>
                      <div class="list-inline-item edit">
                        <a href="javascript:void(0);" class="text-black d-inline-block edit-item-btn mb-1" (click)="showAddNote()">
                          <i class="ri-file-text-line fs-14 border rounded p-2" style="border-color:'#767676;'" tooltipClass="custom-tooltip-sucess" [ngbTooltip]="showTooltips ? 'Add note' : null"></i>
                        </a>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="col-12 border border-success rounded p-3">
                <div class="perfect-scrollbar" style="height:200px" *ngIf="ticketNotes!.length > 0; else noComments">
                  <div class="col-xs-12" *ngFor="let item of ticketNotes">
                    <label class="col-xs-12">
                      {{ item.displayName }}<span *ngIf="item.emailAddress">({{ item.emailAddress }})</span> on
                      {{ item.createdDate | date: 'dd-MM-yyyy h:mm a':'UTC' }}
                    </label>
                    <ng-container [ngTemplateOutlet]="item.isHTML ? commentHTML : commentText">
                      <ng-template #commentHTML>
                        <div class="form-control col-xs-12 html-comment" [innerHTML]="item.body"></div>
                      </ng-template>
                      <ng-template #commentText>
                        <div class="col-xs-12 text-align-left" [innerHTML]="convertNewlinesToBreaks(item.body)"></div>
                      </ng-template>
                    </ng-container>
                    <div class="row mb-4"></div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noComments>
              @if (loadingNoteInfo) {
                <span>Loading...</span>
              } @else {
                <span>{{ error }}</span>
              } 
            </ng-template>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              @if(!embeddedFormMode) {
                <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm(); modal.dismiss('Cross click')">Cancel</button>
              }
              <button type="button" class="btn btn-success" id="add-btn" [disabled]="!this.updateButtonEnabled" (click)="updateTicket()">Update</button>
            </div>
          </div>
        </div>

        <app-spinner-overlay-wrapper
          [showSpinner]="isSubmitting"
        ></app-spinner-overlay-wrapper>

      </div>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>